import { Badge } from '../../components/ui';
import { PROSPECT_TIERS } from './prospects';
import './prospecting.css';

export function ProspectTierChip({ tier }: { tier: string | null }) {
  const entry = PROSPECT_TIERS.find((value) => value.key === tier);
  if (entry === undefined) return null;
  return (
    <span className={`prospect-tier-chip prospect-tier-chip--${entry.key}`}>
      <Badge>{entry.label}</Badge>
    </span>
  );
}
